import {Component, NgZone, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from './shared/services/language.service';
import {GoogleAnalyticsService} from './shared/services/google-analytics-events.service';
import {Gtag} from 'angular-gtag';
import { ConnectionService } from 'ng-connection-service';
import { environment } from '../environments/environment';
import { initializeApp } from 'firebase/app';

// declare ga as a function to set and sent the events
declare let ga: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  options = [
    {name: 'Français', id: 1},
    {name: 'English', id: 2},
  ];

  title = 'LookaBackOffice';
  status = 'ONLINE';
  isConnected = true;

  constructor(
    readonly router: Router,
    private translate: TranslateService,
    private connectionService: ConnectionService,
    private zone: NgZone,
    private languageService: LanguageService,
    public googleAnalyticsService: GoogleAnalyticsService,
    private gtag: Gtag
  ) {
    // Initialize Firebase
    const config = {
      apiKey: environment.firebaseApiKey,
      authDomain: 'looka-643f2.firebaseapp.com',
      databaseURL: 'https://looka-643f2.firebaseio.com',
      projectId: 'looka-643f2',
      storageBucket: 'looka-643f2.appspot.com',
      messagingSenderId: '620491122783',
      appId: '1:620491122783:web:08b8be308f1621083e93ea',
      measurementId: 'G-4G26PKJ4HD'
    };
    initializeApp(config);
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = 'ONLINE';
      } else {
        this.status = 'OFFLINE';
      }
    });

    languageService.selectedLanguage.subscribe(result => {
      translate.addLangs(['en', 'fr']);
      translate.setDefaultLang('en');
      translate.use(result);
    });

    // subscribe to router events and send page views to Google Analytics
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
    if (environment.production) {
      console.warn(`
        Bonjour ! 🙋
        Looka a été conçu par le Lab de YUX.
        Vous voulez travailler avec nous ? Consultez https://www.getlooka.com
        Vous voulez en savoir plus ? Consultez https://www.yux.design
      `);
      console.warn = function (): void {};
      console.error = function (): void {};
      console.log = function (): void {};
    }
  }
}
